import React, { useState } from "react";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { Stack, Table, Button, Badge } from "react-bootstrap";

import * as AiIcons from "react-icons/ai";
import ModalEdit from "../../components/ModalEdit";
import EditMaskShortCode from "./_EditMaskShortCode";
import Confirm from "../../components/Confirm";
import { httpClient } from "../../utils/HttpClient";
import { useAuth } from "../../Context/AuthContext";
import { Tooltip } from "../../components/ui/Tooltip";
const URI = ApiEndpoint + "maskshortcodes/";
import TableSkeleton from "../../components/ui/Skeleton/TableSkeleton";
import { useQuery } from "@tanstack/react-query";
import _Button from "../../components/generic/_Button";
const MaskShortCodes = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [shortCodesMasks, setShortCodesMasks] = useState([]);
  const [show, setShow] = useState(false);
  const ModalHandleClose = () => setModalShowConfirm(false);

  const [idShortCodeMask, setIdShortCodeMask] = useState(0);
  const [modalShowConfirm, setModalShowConfirm] = useState(false);
  const [idRecordToInactivate, setIdRecordToInactivate] = useState(false);
  const handleConfirm = () => {
    setModalShowConfirm(false);
    InactivateKeyword();
  };
  const handleClose = () => {
    getShortCodesMasks();
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const getShortCodesMasks = () => {
    httpClient("GET", URI, {}, userData.token).then((response) => {
      setShortCodesMasks(response.data);
    });
  };

  const { isPending } = useQuery({
    queryKey: ["shortCodesMasks"],
    queryFn: getShortCodesMasks,
  });

  const InactivateKeyword = () => {
    const URIDb =
      ApiEndpoint + "deactivatemaskshortcode/" + idRecordToInactivate;

    httpClient("DELETE", URIDb, {}, userData.token)
      .then(function () {
        getShortCodesMasks();
        setModalShowConfirm(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const renderTable = () => {
    if (isPending) {
      return <TableSkeleton />;
    }

    return (
      <Table striped className="mt-3 bg-white rounded-lg">
        <thead>
          <tr>
            <th>Marcación</th>
            <th>Carrier</th>
            <th>Mascara</th>
            <th>Activa</th>
            <th className="w-[100px]"></th>
          </tr>
        </thead>
        <tbody>
          {shortCodesMasks &&
            shortCodesMasks.map((item) => {
              return (
                <tr key={item.id_shortcode_mask}>
                  <td>{item.vc_shortcode}</td>
                  <td>{item.vc_carrier}</td>
                  <td>{item.vc_mask}</td>
                  <td>
                    <>
                      {item.b_active ? (
                        <Badge bg="primary">Activo</Badge>
                      ) : (
                        <Badge bg="secondary">Inactivo</Badge>
                      )}
                    </>
                  </td>
                  <td className="flex justify-end gap-2">
                    <Tooltip message="Editar">
                      <_Button
                        style="none"
                        icon="edit"
                        onClick={() => {
                          setIdShortCodeMask(item.id_shortcode_mask);
                          handleShow();
                        }}
                      />
                    </Tooltip>
                    <Tooltip message="Desactivar">
                      <_Button
                        style="none"
                        icon="visibility_off"
                        onClick={() => {
                          setIdRecordToInactivate(item.id_shortcode_mask);

                          setModalShowConfirm(true);
                        }}
                      />
                    </Tooltip>

                    {/* <AiIcons.AiOutlineDelete className="IconTable" /> */}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  };

  return (
    <>
      <div>
        <Stack direction="horizontal" gap={2} className="AlignItemsTop">
          <div>
            <h2>Mascaras para Marcaciones</h2>
            <h3>Administre la lista de Mascaras.</h3>
          </div>
          <div className="ms-auto">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setIdShortCodeMask(0);
                setShow(true);
              }}
            >
              <AiIcons.AiOutlinePlus /> Agregar
            </Button>{" "}
          </div>
        </Stack>

        {renderTable()}
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title={idShortCodeMask > 0 ? "Editar Mascara" : "Agregar Mascara"}
      >
        <EditMaskShortCode
          show={show}
          idMaskShortCode={idShortCodeMask}
          handleClose={handleClose}
        />
      </ModalEdit>
      <Confirm
        show={modalShowConfirm}
        handleClose={ModalHandleClose}
        handleConfirm={handleConfirm}
        message={"Desea Cambiar desactivar la Mascara seleccionada?"}
      />
    </>
  );
};

export default MaskShortCodes;
